<div class="ds-flatpickr-date">
  <label class="ds-flatpickr-date__label">
    {{ label() }}
    @if (required()) {
      <span class="ds-flatpickr-date__required">*</span>
    }
  </label>

  <div class="ds-flatpickr-date__input-wrap">
    <input
      #input
      class="ds-input ds-flatpickr-date__input"
      type="text"
      readonly
      [placeholder]="placeholder()"
      [disabled]="disabled()"
    />

    <span class="ds-flatpickr-date__icon" aria-hidden="true">
      <ng-container
        [ngComponentOutlet]="calendarIcon"
        [ngComponentOutletInputs]="{ size: 20, strokeWidth: 2 }"
      />
    </span>
  </div>
</div>
